import type { CurveMeta, ExportMeta, Manifest } from './types.ts';

export async function loadManifest(url = '/data/manifest.json'): Promise<Manifest> {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`manifest: HTTP ${r.status}`);
  const m = (await r.json()) as Manifest;
  if (m.schema !== 'curves.manifest.v1') throw new Error(`manifest: unexpected schema ${String(m.schema)}`);
  return m;
}

export function findCurve(m: Manifest, id: string): CurveMeta | undefined {
  return m.curves.find((c) => c.id === id);
}

export function findExport(curve: CurveMeta, id: string): ExportMeta | undefined {
  return curve.exports.find((e) => e.id === id);
}

/**
 * Iteration a curve opens at: the defaults of the Spacefilling Curve Atlas
 * page (its depth numbering matches ours). Curves not listed open at their
 * deepest export.
 */
const DEFAULT_DEPTH: Record<string, number> = {
  hilbertcurve: 6, pinwheelcurve: 6, penrosecurve: 5, hatcurve: 5, spectrecurve: 5, quaquaversalcurve: 4,
};

export function defaultExport(curve: CurveMeta): ExportMeta {
  const want = DEFAULT_DEPTH[curve.id];
  if (want !== undefined) {
    const hit = curve.exports.find((e) => e.depth === want);
    if (hit) return hit;
  }
  return curve.exports[curve.exports.length - 1];
}
